import { render, staticRenderFns } from "./BaseDataImport.vue?vue&type=template&id=2aed011d&scoped=true"
import script from "./BaseDataImport.vue?vue&type=script&lang=js"
export * from "./BaseDataImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aed011d",
  null
  
)

export default component.exports